import { form } from "./form";

/** @type {import("vuex/types/index.d.ts").Module} */
export const employment = {
    namespaced: true,
    modules: { form },
};

export default employment;
